import styled from 'styled-components';

const mapLabelSize = (v) => {
  switch (v) {
    case 1:
      return '24px';
    case 2:
      return '20px';
    case 3:
      return '16px';
    default:
      return '16px';
  }
};

const mapLabelColor = (v) => {
    switch (v) {
      case 'warning':
        return '#DC2626';
      default:
        return '#6B7280';
    }
  };

export const Label = styled.label.attrs({
  className: 'text-black',
})`
  color: ${({ type }) => mapLabelColor(type)};
  font-size: ${({ level }) => mapLabelSize(level)};
`;

export const ImgWrapper = styled.div`
  width: 100%;
  padding-left: 20%;
  padding-right: 20%;
  padding-bottom: 15px;
`;

export const Img = styled.img``;

export const Input = styled.input`
  color: #6b7280;
  padding: 8px;
  width: 100%;
  margin-top: 15px;
  border: 1px solid #6b7280;
  border-radius: 10px;
  text-align: center;
  font-size: 20px;

  &::placeholder {
    color: #6B7280;
  }
`;

export const Button = styled.button`
  font-size: 16px;
  color: #ffffff;
  margin-top: 15px;
  padding: 8px 24px;
  border: 0px;
  border-radius: 10px;
  cursor: pointer;
`;

export const ConfirmButton = styled(Button)`
  background-color: #10B981;

  &:hover {
    background-color: #34D399;
  }
`

export const BackButton = styled(Button)`
  background-color: #6B7280;

  &:hover {
    background-color: #9CA3AF;
  }
`
